module.exports = __webpack_public_path__ + "static/4_icon-0bd649c2fb9b32f420951986756f565c.svg";